import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoriesService } from '../../../../services/api/general-settings/categories.service';
import { CategoryFormComponent } from '../components/category-form/category-form.component';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';

@Component({
  selector: 'app-category-edit',
  imports: [CategoryFormComponent],
  templateUrl: './category-edit-page.component.html',
  styleUrl: './category-edit-page.component.scss'
})
export class CategoryEditPageComponent implements OnInit {
  categoryId!: number
  category?: any;

  constructor(
    private route: ActivatedRoute,
    private categoriesService: CategoriesService,
  ) {
  }

  ngOnInit(): void {
    this.categoryId = Number(this.route.snapshot.paramMap.get('categoryId'));
    if (this.categoryId) {
      this.loadData(this.categoryId);
    }
  }

  loadData(categoryId: any) {
    this.categoriesService.detail(categoryId).subscribe((response: any) => {
      this.category = response.data?.category;
    });

  }

}
